// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__G+OD9","footer":"App_footer__tVHZw","tester":"App_tester__rKKcW","header":"App_header__v7pPK"};